import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { FIVE_MINUTES } from '../../helpers/timeConstants';
import { getEntitlements, getEntitlementsKey } from '../../services/entitlements.service';
import { hasEntitlementFeature } from './utils/hasEntitlementFeature.utils';

export const useHasEntitlement = (
  orgId?: string,
  featureCode?: string,
  options?: { enabled?: boolean }
) => {
  const queryEnabled = !!orgId && !!featureCode && (options?.enabled ?? true);

  const { data, isLoading, isError } = useQuery({
    queryKey: [getEntitlementsKey, orgId],
    queryFn: () => {
      if (!orgId) {
        return Promise.reject(new Error('orgId is required'));
      }
      return getEntitlements(orgId);
    },
    enabled: queryEnabled,
    staleTime: FIVE_MINUTES,
  });

  const hasEntitlement = useMemo(
    () => hasEntitlementFeature(data?.features, featureCode ?? ''),
    [data?.features, featureCode]
  );

  return {
    hasEntitlement,
    isLoading,
    isError,
  };
};

export default useHasEntitlement;
